!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react"), require("react-spring")) : "function" == typeof define && define.amd ? define(["react", "react-spring"], t) : e["react-swipy"] = t(e.React, null);
}(this, function (w, h) {
  "use strict";

  var m = "default" in w ? w.default : w,
      s = function s(n) {
    return function (e) {
      return n((t = e, t.touches ? t.touches[0] : t).pageX);
      var t;
    };
  };

  function f(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  var v = {
    tension: 390,
    friction: 30,
    restSpeedThreshold: 1,
    restDisplacementThreshold: .01,
    overshootClamping: !0,
    lastVelocity: 1,
    mass: .1
  },
      p = {
    start: 0,
    offset: 0,
    forced: !1,
    swiped: !1,
    moving: !1,
    pristine: !0
  },
      e = function (r) {
    function i() {
      var e, a;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, i);

      for (var t = arguments.length, n = Array(t), o = 0; o < t; o++) {
        n[o] = arguments[o];
      }

      return (e = a = f(this, r.call.apply(r, [this].concat(n)))).state = p, a.onDragStart = s(function (e) {
        a.state.swiped || a.setState({
          start: e,
          pristine: !1,
          moving: !0
        });
      }), a.onDragMove = s(function (e) {
        var t,
            n,
            o = a.state,
            r = o.start,
            i = o.swiped,
            s = o.moving;
        !i && s && a.setState({
          offset: (t = r, n = e, -.75 * (t - n))
        });
      }), a.onDragEnd = function () {
        var e = a.state,
            t = e.offset,
            n = e.swiped,
            o = e.moving,
            r = a.props.limit;
        !n && o && (Math.abs(t) >= r ? a.onBeforeSwipe(0 < t ? "right" : "left") : a.onCancelSwipe());
      }, a.onCancelSwipe = function () {
        return a.setState({
          start: 0,
          offset: 0,
          moving: !1
        });
      }, a.onBeforeSwipe = function (t) {
        var e = a.props.onBeforeSwipe;
        e ? e(function (e) {
          return a.onSwipe(e || t);
        }, a.onCancelSwipe, t) : a.onSwipe(t);
      }, a.onSwipe = function (e) {
        var t,
            n,
            o = a.props,
            r = o.limit,
            i = o.onSwipe;
        i && i(e), a.setState({
          swiped: !0,
          moving: !1,
          offset: (t = r, n = e, "right" === n ? t : -t)
        });
      }, a.onAfterSwipe = function () {
        var e = a.props.onAfterSwipe;
        a.setState(p), e && e();
      }, a.forceSwipe = function (e) {
        a.state.swiped || (a.setState({
          pristine: !1,
          forced: !0
        }), a.onBeforeSwipe(e));
      }, f(a, e);
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(i, r), i.prototype.componentDidMount = function () {
      window.addEventListener("touchmove", this.onDragMove), window.addEventListener("mousemove", this.onDragMove), window.addEventListener("touchend", this.onDragEnd), window.addEventListener("mouseup", this.onDragEnd);
    }, i.prototype.componentWillUnmount = function () {
      window.removeEventListener("touchmove", this.onDragMove), window.removeEventListener("mousemove", this.onDragMove), window.removeEventListener("touchend", this.onDragEnd), window.removeEventListener("mouseup", this.onDragEnd);
    }, i.prototype.render = function () {
      var e,
          t,
          n,
          o = this,
          r = this.state,
          i = r.offset,
          s = r.swiped,
          a = r.pristine,
          f = r.forced,
          p = this.props,
          c = p.children,
          u = p.limit,
          d = p.buttons,
          l = p.min;
      return m.createElement(w.Fragment, null, m.createElement(h.Spring, {
        from: {
          offset: 0,
          opacity: 1
        },
        to: {
          offset: i,
          opacity: (e = i, t = u, n = l, 1 - (Math.abs(e) < n ? 0 : (Math.abs(e) - n) / Math.abs(t - n)))
        },
        onRest: function onRest() {
          return s && o.onAfterSwipe();
        },
        immediate: a || !f && Math.abs(i) >= u,
        config: v
      }, function (e) {
        var t = e.offset,
            n = e.opacity;
        return m.createElement("div", {
          style: {
            opacity: n,
            transform: "translateX(" + t + "px) rotate(" + t / 10 + "deg)",
            height: "100%",
            width: "100%"
          },
          onMouseDown: o.onDragStart,
          onTouchStart: o.onDragStart
        }, c);
      }), d && d({
        right: function right() {
          return o.forceSwipe("right");
        },
        left: function left() {
          return o.forceSwipe("left");
        }
      }));
    }, i;
  }(w.PureComponent);

  return e.defaultProps = {
    limit: 120,
    min: 40
  }, e;
});